import { useContext } from 'react';
import { Lobby } from './Lobby';
import { SearchForms } from './SearchForms';
import { SuppliersContext } from 'Context/SuppliersContext';
import { ResultPages } from './ResultsPages';

export const SuppliersMain = () => {
  const { stepIndex } = useContext(SuppliersContext);

  const getStepContent = () => {
    switch (stepIndex) {
      default:
      case 0:
        return <Lobby />;

      case 1:
        return <SearchForms />;

      case 2:
        return <ResultPages />;
    }
  };

  return getStepContent();
};
